/**
 * Sorts product variant dropdown options numerically/alphabetically.
 * Handles prefixed values like "EU 35", "EU 40", "XS", "S", "M", "L", "XL" etc.
 * Place this script in your theme.liquid before </body>, or load it as an asset.
 */

(function () {
  // Known size order for clothing sizes — extend as needed
  const SIZE_ORDER = ['XXXS','XXS','XS','S','M','L','XL','XXL','XXXL','2XL','3XL','4XL','OS','ONE SIZE'];

  /**
   * Extracts a numeric value from a string for sorting purposes.
   * "EU 35" → 35, "UK 8.5" → 8.5, "S" → index in SIZE_ORDER, "Blue" → NaN
   */
  function getSortKey(text) {
    const normalized = text.trim().toUpperCase();

    // Check against known clothing size order first
    const sizeIndex = SIZE_ORDER.indexOf(normalized);
    if (sizeIndex !== -1) return sizeIndex;

    // Extract any number (including decimals) from the string
    const match = normalized.match(/[\d]+(?:[.,]\d+)?/);
    if (match) return parseFloat(match[0].replace(',', '.'));

    // Fall back to alphabetical (return the string itself for localeCompare)
    return null;
  }

  function sortOptionList(ul) {
    const items = Array.from(ul.querySelectorAll('li'));
    if (items.length < 2) return;

    items.sort(function (a, b) {
      const textA = a.querySelector('label')?.textContent?.trim() || a.textContent.trim();
      const textB = b.querySelector('label')?.textContent?.trim() || b.textContent.trim();

      const keyA = getSortKey(textA);
      const keyB = getSortKey(textB);

      // Both numeric → numeric sort
      if (keyA !== null && keyB !== null && typeof keyA === 'number' && typeof keyB === 'number') {
        return keyA - keyB;
      }

      // Both strings → locale-aware alphabetical
      return textA.localeCompare(textB, undefined, { sensitivity: 'base' });
    });

    // Re-append in sorted order (DOM reorder, no re-render needed)
    items.forEach(function (li) { ul.appendChild(li); });
  }

  function sortAllVariantDropdowns() {
    // Targets the <ul class="product-form__controls-group"> inside dropdown selects
    document
      .querySelectorAll('.dropdown-select ul.product-form__controls-group')
      .forEach(sortOptionList);
  }

  // Run on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortAllVariantDropdowns);
  } else {
    sortAllVariantDropdowns();
  }

  // Re-run when Shopify re-renders variant sections (e.g. after variant change)
  document.addEventListener('variant:changed', sortAllVariantDropdowns);

  // Also observe for dynamic rendering (e.g. quick-view drawers)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        const lists = node.querySelectorAll
          ? node.querySelectorAll('.dropdown-select ul.product-form__controls-group')
          : [];
        lists.forEach(sortOptionList);
        // Also check if the node itself is the list
        if (node.matches && node.matches('.dropdown-select ul.product-form__controls-group')) {
          sortOptionList(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
